import { getStarted } from '@/app/api';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IStartet } from '@/pages/startet/types';

interface IIntialState {
  data: IStartet[];
  loading: boolean;
}

const initialState: IIntialState = {
  data: [],
  loading: false,
};

export const fetchStartet = createAsyncThunk<IStartet[], void>(
  'startet/fetchStartet',
  async () => {
    const response = await getStarted();
    return response.data;
  }
);

const startetSlice = createSlice({
  name: 'startet',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStartet.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchStartet.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchStartet.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default startetSlice.reducer;
